import i18n from '@/plugins/i18n';
import translationsApi from '@/api/translationsApi';

const state = {
  selectedLang: 'de',
  locale: 'de-CH',
  languageKeys: [],
};

const getters = {};

const mutations = {
  setLanguage(state, { lang, translations }) {
    console.debug('setLanguage', lang);
    i18n.locale = lang;
    i18n.setLocaleMessage(lang, translations);
    localStorage.setItem('lang', lang);
    state.selectedLang = lang;
  },
};

const actions = {
  loadDefaultLanguage: async ({ commit, dispatch, rootState }, { lang }) => {
    console.log('loadDefaultLanguage', lang);
    let languageKeys = rootState.configs.languageKeys;
    let languageToLoad = getLanguageToLoad(lang, languageKeys);

    try {
      let response = await translationsApi.loadDefaultLanguage(languageToLoad);
      let { translations } = response.data;
      commit('setLanguage', { lang: languageToLoad, translations });
    } catch (err) {
      console.warn('Failed to load translations, but use language keys as fallback (to avoid being stuck within the current lifecycle phase)', err);
    }
    dispatch(
      'lifecycle/setAppStates',
      {
        isDefaultLanguageLoaded: true,
        logMsg: 'App language file loaded',
      },
      { root: true }
    );
  },
  /**
   * Loads the appropriate language file in the given @param lang. If the localStorage property lang is set and differs from the provided lang, the localStorage property lang is prioritized.
   * localStorage.locale is the locale set within the cockpit
   * localStorage.lang is the current language to use (and being set in user settings)
   * @param commit
   * @param dispatch
   * @param lang
   * @returns {Promise<void>}
   */
  loadLanguage: async ({ commit, dispatch, rootState }, { lang }) => {
    console.log('loadLanguage', lang);
    let languageKeys = rootState.configs.languageKeys;
    let languageToLoad = getLanguageToLoad(lang, languageKeys);

    try {
      let response = await translationsApi.loadLanguage(languageToLoad);
      let { translations } = response.data;
      commit('setLanguage', { lang: languageToLoad, translations });
    } catch (err) {
      console.warn('Failed to load translations, but use language keys as fallback (to avoid being stuck within the current lifecycle phase)', err);
    }
    dispatch(
      'lifecycle/setAppStates',
      {
        isLanguageLoaded: true,
        logMsg: 'Tenant language file loaded',
      },
      { root: true }
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

function getLanguageToLoad(lang, languageKeys) {
  let languageToLoad = lang;
  let localStorageLang = localStorage.getItem('lang') || null;
  let browserLanguage = navigator.language.split('-')[0];

  console.log(`getLanguageToLoad lang=${lang} and localStorageLang=${localStorageLang} browserLanguage${browserLanguage}`);

  // browserLanguage overrides default

  if (!localStorageLang || localStorageLang === 'undefined') {
    if (languageKeys.includes(browserLanguage) && browserLanguage && browserLanguage !== lang) {
      languageToLoad = browserLanguage;
      console.log(`browserLanguage ${browserLanguage} overrides requested lang ${lang}`);
    }
  }

  // localStorage setting has Priority because user can override cockpit and system setting
  if (localStorageLang && localStorageLang !== 'undefined' && localStorageLang !== lang) {
    console.log(`localStorage setting ${localStorageLang} overrides requested/browserLang ${languageToLoad}`);
    languageToLoad = localStorageLang;
  }

  return languageToLoad;
}
